import type { DirectionsCardData, DirectionsTravelMode } from '../../lib/conversationsApi';
import './directionsCard.css';

const MODE_LABEL: Record<DirectionsTravelMode, string> = {
  DRIVE: 'Driving',
  WALK: 'Walking',
  BICYCLE: 'Cycling',
  TRANSIT: 'Transit',
};

export function DirectionsCard({ directions }: { directions: DirectionsCardData }) {
  return (
    <section className="ozira-directions-card" aria-label={`Directions from ${directions.origin} to ${directions.destination}`}>
      <div className="ozira-directions-card__brand"><span>OZIRA Live</span><strong>Google Maps</strong><span className="ozira-directions-card__verified">Verified</span></div>
      <div className="ozira-directions-card__route">
        <span className="ozira-directions-card__point">{directions.origin}</span>
        <span className="ozira-directions-card__arrow" aria-hidden="true">→</span>
        <span className="ozira-directions-card__point">{directions.destination}</span>
      </div>
      {directions.summary ? <p className="ozira-directions-card__summary">{directions.summary}</p> : null}
      <div className="ozira-directions-card__stats">
        <span className="ozira-directions-card__mode">{MODE_LABEL[directions.mode]}</span>
        <span>{directions.distanceText}</span>
        <span>{directions.durationText}</span>
      </div>
      <div className="ozira-directions-card__actions">
        <a href={directions.mapsUrl} target="_blank" rel="noreferrer">Open in Google Maps</a>
      </div>
      <p className="ozira-directions-card__attribution" translate="no">Google Maps</p>
    </section>
  );
}
